<template>
    <div class="range-bar">
        <span class="range-bar__sold">
            {{ sold }}
        </span>
        <div class="range-bar__display">
            <div class="range-bar__display-sold" :style="{'width': sold_bar_width + '%'}"></div>
        </div>
        <span class="range-bar__amount">
            {{ amount }}
        </span>
    </div>
</template>

<script>
    export default {
        name: "RangeBar",
        props: {
            sold: {
                type: [Number, String],
                default: ''
            },
            amount: {
                type: [Number, String],
                default: ''
            }
        },
        computed: {
            sold_bar_width() {
                if(this.sold && this.amount) {
                    return Math.round((this.sold/this.amount)*100);
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .range-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        &__sold {
            color: #878EA0;
        }
        &__display {
            flex: 1;
            position: relative;
            background: #E1E6EA;
            border-radius: 99px;
            height: 6px;
            margin: 0 8px;
            &-sold {
                position: absolute;
                background: linear-gradient(38.29deg, #7AC3C1 0%, #3FB0AB 100%);
                border-radius: 99px;
                height: 6px;
            }
        }
        &__amount {
            color: #878EA0;
        }
    }
</style>